/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Empty, Image, Tag } from 'antd';
import { PaperClipOutlined, GlobalOutlined, EyeOutlined } from '@ant-design/icons';
import Style from './style';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { verifyConditional } from '../../helper';
import { useTranslation } from 'react-i18next';
import { propHasValue } from '../../../../components/DynamicFormNew/helper';
import { BasicInput } from '../../components/input';
import { DownloadOutlined, FileAddOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Table } from 'antd';
import { openDSWindow, openArmWindow } from '../../../../helpers/Window';
import AuthenticationService from '../../../../services/AuthenticationService';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { getLocales } from '../../../../components/Table/newTable';

function DocumentComponent({
  conf: {
    form,
    data,
    linkingForms,
    linkingData,
    match,
    allData,
    canEdit,
    mode,
  },
  user,
  location,
  project: { data: { projects }, retrived: projectsRetrived },
  authentication: { selectedProject },
}) {
  const excludeKeys = ['position', 'label'];
  const [documents, setDocuments] = useState([]);
  const { pathname } = useLocation();
  const push = useNavigate();
  const { namespace } = useParams();
  const [images, setImages] = useState([]);
  const { t } = useTranslation();
  const [, mod] = useMemo(() => isProxy()
    ? pathname.split(/\/proxy\/(pme|cadd)\/view/)
    : pathname.split(/\/app\/(pme|cadd)\/view/), [pathname]);

  const label = (input, iData) => {
    const lbl = input.outputLabel ? input.outputLabel : input.label;
    switch (typeof lbl) {
      case 'string':
        return lbl;
      case 'object':
        const labelKey = Object.keys(lbl)[0];
        return lbl[labelKey];
      default:
        return lbl;
    }
  }

  const getTable = () => {
    const parent = 'documents';
    const isRepeatable = true;
    const defaultKey = Object.keys(linkingForms.documents)[0];
    const linkingD = linkingData ? (linkingData.Documents || {}) : {};
    const modalData = data[parent] ? (
      !Array.isArray(data[parent])
        ? typeof data[parent] === 'string'
          ? linkingD[data[parent]]
          : (linkingD[data[parent]] || {})
        : (data[parent].map(item => {
          if (item) {
            Object.assign(item, {
              ...linkingD[item]
            });
          }
          return item;
        }) || {})) : (isRepeatable ? [] : {});

    const form = Object.keys(linkingForms[parent][defaultKey])
      .reduce((f, key) => {
        const input = linkingForms[parent][defaultKey][key];
        if (!excludeKeys.includes(key)) {
          if (input.showIf && !propHasValue(input.table)) {
            if (verifyConditional(input.showIf, modalData, modalData)) {
              f[key] = linkingForms[parent][defaultKey][key];
            }
          } else {
            f[key] = linkingForms[parent][defaultKey][key];
          }
        }
        return f;
      }, {});

    const formInputs = Object.keys(form)
      .filter(i => !excludeKeys.includes(i));

    let repeatableTableCols = formInputs
      .map(i => ({
        key: i,
        ...form[i],
      }))
      .filter(i => propHasValue(i.table))
      .sort((a, b) => a.table - b.table)
      .map((i, iIndex) => {
        return {
          key: iIndex + 1,
          dataIndex: i.key,
          title: label(i),
          render: (_, item) => {
            switch (i.key) {
              case 'datastakeId':
                if (mode === 'proxy') {
                  return (
                    <span
                      style={{ color: 'var(--mmt-primary-70)', cursor: 'pointer' }}
                      onClick={() => {
                        openDSWindow({
                          url: `/proxy/${mod}/viewdd/document/${item.datastakeId}`,
                          name: `Datastake Document ${item.datastakeId}`,
                        })
                      }}
                    >
                      {item.datastakeId}
                    </span>
                  );
                }

                return (
                  <a
                    href={`/app/${mod}/viewdd/document/${item.datastakeId}`}
                    target="_blank" rel="noreferrer"
                  >
                    {item.datastakeId}
                  </a>
                );
              case 'type':
                return (
                  <Tag
                    className="type-tag"
                    icon={item.type === 'link' ? <GlobalOutlined /> : <PaperClipOutlined />}
                  >
                    {item.type === 'link' ? t('Link') : item.type === 'asmo' ? t('Asmo') : t('Document')}
                  </Tag>
                );
              default:
                return (
                  <BasicInput
                    name={i.key}
                    valueOnly={true}
                    config={i}
                    data={item}
                  />
                );
            }
          },
          width: i.key === 'type' ? 100 : undefined,
        };
      })

    repeatableTableCols = repeatableTableCols.concat([
      {
        key: 'actions',
        title: t('Actions'),
        width: 90,
        render: (item, all) => {
          return <div style={{ textAlign: 'center' }}>
            {/* <Button
              style={{ marginRight: '8px', borderStyle: 'dashed' }}
              icon={<EyeOutlined />}
              type="primary"
              ghost
              onClick={() => {
              }}
            /> */}
            {Array.isArray(item.documents) && item.documents.filter(d => d.url).length > 0 ? <Button
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => {
                (item.documents || []).filter(d => d.url).forEach(d => {
                  const element = document.createElement('a');
                  if (!d.url.includes('https://')) {
                    d.url = `https://${d.url}`;
                  }
                  element.setAttribute('href', d.url);
                  element.setAttribute('target', '_blank');
                  element.style.display = 'none';
                  document.body.appendChild(element);
                  element.click();
                  document.body.removeChild(element);
                })
              }}
            /> : null}
            {all.type === 'asmo' && (
              <Button
                icon={<EyeOutlined />}
                size="small"
                onClick={async () => {
                  const res = await AuthenticationService.armToken();
                  openArmWindow({
                    url: `/proxy/analysis/asmos/${all.asmoId}?proxy_token=${res.data}`,
                    name: 'Arm Proxy',
                  })
                }}
              />
            )}
          </div>;
        },
      },
    ]);

    const dataSource = documents.map((d, i) => ({
      ...d,
      key: `${d.i}-${i}`,
    }));

    return <div className='wrapper'>
      <div className="table-body">
        <Table
          locale={getLocales(t)}
          size="small"
          bordered
          rowKey="key"
          columns={repeatableTableCols}
          dataSource={dataSource}
          pagination={false}
        />
      </div>
    </div >;
  }

  const addDocumentClicked = (type = '') => {
    let path = 'documentation';

    if (((data || {}).datastakeId || '').includes('EV-')) {
      path = 'eventDocumentation';
    }

    switch (data.namespace) {
      case 'Events':
        path = 'eventDocumentation';
        break;
      default:
    }

    const link = `/${mode}/${mod}/edit/${namespace}/${data.datastakeId}/${path}?documentType=${type}`;
    push(link);
  };

  useEffect(() => {
    if (data && data.documents && linkingData && linkingData.Documents) {
      const allDocuments = data.documents.map(d => linkingData.Documents[d.documentId]).filter(d => d);
      setDocuments(allDocuments.filter(d => d.type !== 'picture'));
      const imageDocuments = allDocuments.filter(d => d.type === 'picture' && d.pictures);
      const allImages = imageDocuments.reduce((a, item) => {
        const fileList = item &&
          item.pictures ? (Array.isArray(item.pictures) ? item.pictures : (Array.isArray(item.pictures.fileList) ? item.pictures.fileList : [])) : [];
        fileList.forEach(v => {
          const img = v.response ? v.response : v;
          img.title = item.title;
          img.description = item.dscription;
          a.push(img);
        })
        return a;
      }, []).filter(v => v.url);
      setImages(allImages);
    }
  }, [data, linkingData]);

  return (
    <Style className="content">
      <h1 className='title'>{t('Gallery')}</h1>
      {images.length === 0 ? (
        <div className='documnet-container-empty'>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={(
              <div>
                <span>{t('Looks like there is no images for this subject')}</span>
                {canEdit && (
                  <div className="buttons">
                    <Button
                      type="primary"
                      icon={<FileAddOutlined />}
                      className="big-width"
                      onClick={() => addDocumentClicked('picture')}
                    >
                      {t('Add a picture')}
                    </Button>
                  </div>
                )}
              </div>
            )}
          />
        </div>
      ) : (
        <div className="image-container">
          <Image.PreviewGroup>
            {images.map((i, k) => (
              <Image
                alt={i.title}
                placeholder={i.title}
                about={i.description}
                key={k}
                width={200}
                src={i.url}
              />
            ))}
          </Image.PreviewGroup>
        </div>
      )}
      <h1 className='title'>{t('Documents')}</h1>
      {documents.length === 0 ? (
        <div className='documnet-container-empty'>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={(
              <div>
                <span>{t('Looks like there are no files or links for this subject')}</span>
                {canEdit && (
                  <div className="buttons">
                    <Button
                      type="primary"
                      onClick={() => addDocumentClicked('document')}
                    >
                      {t('Add a document')}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => addDocumentClicked('link')}
                    >
                      {t('Add a link')}
                    </Button>
                  </div>
                )}
              </div>
            )}
          />
        </div>
      ) : (
        <div>
          {getTable()}
        </div>
      )}
    </Style>
  );
}

export const Documents = connect(({ authentication, project }) => ({ authentication, project }), null)(DocumentComponent);
